var data = {
  valuationData: {
    mileage: '',
    registrationDate: '',
    cityCode: '',
    cityName: '',
    provinceCode: '',
    provinceName: '',
    carDataName: '',
    carDetailName: ''
  }
};
var mutations = {
  SET_VALUATION_DATA: function SET_VALUATION_DATA(data, newDate) {
    data.valuationData = newDate;
  }
};
export default {
  data: data,
  mutations: mutations
};